export default "__VITE_ASSET__TTLVRqS1__"